import styles from "./Share.module.css";
import React from "react";
import facebook from "../static/images/component_svg/Facebook.svg";
import line from "../static/images/component_svg/Line.svg";
import share from "../static/images/component_svg/share.svg";
import Copy from "../static/images/component_svg/Copy.svg";
import twitter from "../static/images/component_svg/Twitter.svg";

function Share({url: currentUrl}) {

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isNativeShareSupported =
    typeof navigator !== "undefined" && !!navigator.share;

  const showNativeShare = isMobile && isNativeShareSupported;

  function handleCopyLink() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => alert("Link copied to clipboard!"))
        .catch((err) => {
          console.error("Clipboard error:", err);
          fallbackCopy(currentUrl);
        });
    } else {
      fallbackCopy(currentUrl);
    }
  }

  function fallbackCopy(text) {
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    alert("Link copied to clipboard!");
  }

  function handleNativeShare() {
    navigator
      .share({
        title: "Check this out!",
        text: "Have a look at this page:",
        url: currentUrl,
      })
      .catch((error) => console.error("Error sharing", error));
  }

  return (
    <div className={styles.share}>
      {showNativeShare ? (
        <>
          <button onClick={handleNativeShare}>
            <div className={styles.nativeShareButton}>
              <img src={share} alt="Share Native" />
              Share
            </div>
          </button>
        </>
      ) : (
        <>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              currentUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebook} alt="Share on Facebook" />
          </a>

          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              currentUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitter} alt="Share on Twitter" />
          </a>

          <a
            href={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
              currentUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={line} alt="Share on LINE" />
          </a>
        </>
      )}
      <button onClick={handleCopyLink}>
        <img src={Copy} alt="Copy link" />
      </button>
    </div>
  );
}

export default Share;
